import { NavigationItem } from '../../../types';

export const navigationConfig: NavigationItem[] = [
  { id: 'campaign-assistant', name: 'Asistente Reveca', icon: 'sparkles', category: 'main' },
  { id: 'renewals', name: 'Campañas', icon: 'megaphone', category: 'main' },
  { id: 'report', name: 'Reporte', icon: 'report', category: 'main' },
  { id: 'inbox', name: 'Bandeja de entrada', icon: 'message-circle', category: 'main' },
  { id: 'templates', name: 'Plantillas', icon: 'file-text', category: 'components' },
  { id: 'sheets', name: 'Google Sheets', icon: 'sheet', category: 'config' },
  { id: 'calendar', name: 'Google Calendar', icon: 'calendar', category: 'config' },
  { id: 'whatsapp', name: 'WhatsApp', icon: 'whatsapp', category: 'config' },
  { id: 'payment', name: 'Suscripciones', icon: 'credit-card', category: 'payment' },
];

export const adminNavigation: NavigationItem[] = [
  { id: 'admin', name: 'Administración', icon: 'admin', category: 'admin' },
];
